import { AuthAction } from "../actions/authActions";
import { jwtDecode } from "jwt-decode";
import {
	extractKnownRoles,
	JWT_ROLE_CLAIM,
} from "../../auth/roles";

interface AuthState {
	accessToken: string | null;
	id: string | null;
	username: string | null;
	email: string | null;
	exp: number | null;
	permissions: string[];
	/** Known OperationClaim role names from the JWT (Superadmin / Admin / User). */
	roles: string[];
}

// JWT token'ından gelen claims için özel interface
interface CustomJwtPayload {
	exp: number;
	iss: string;
	nbf: number;
	'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
	'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress': string;
	/** One claim → string; multiple role claims → string[] (jwt-decode). */
	'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'?: string | string[];
	permissions?: string[];
}

const initialState: AuthState = {
	accessToken: null,
	id: null,
	username: null,
	email: null,
	exp: null,
	permissions: [],
	roles: [],
};

const authReducer = (state = initialState, action: AuthAction): AuthState => {
	switch (action.type) {
		case 'LOGIN': {
			const decoded = jwtDecode<CustomJwtPayload>(action.payload.accessToken);
			const userId = decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']?.replace(/['"]+/g, '');
			const email = decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'];
			localStorage.setItem("userId", userId || '');

			const permissions = action.payload.permissions || [];
			const roles = extractKnownRoles({
				roleClaim: decoded[JWT_ROLE_CLAIM],
				permissions,
			});

			return {
				...state,
				...decoded,
				id: userId,
				email: email,
				...action.payload,
				permissions,
				roles,
			};
		}
		case 'LOGOUT':
			localStorage.removeItem('userId');
			return { ...initialState };
		default:
			return state;
	}
};

export default authReducer;
